/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchFilterOnBackground } from './';
import {
    SourcingSearchFilterOnBackgroundFromJSON,
    SourcingSearchFilterOnBackgroundFromJSONTyped,
    SourcingSearchFilterOnBackgroundToJSON,
} from './';
import type { SourcingSearchFilterOnDailyRate } from './';
import {
    SourcingSearchFilterOnDailyRateFromJSON,
    SourcingSearchFilterOnDailyRateFromJSONTyped,
    SourcingSearchFilterOnDailyRateToJSON,
} from './';
import type { SourcingSearchFilterOnFunctionalSkills } from './';
import {
    SourcingSearchFilterOnFunctionalSkillsFromJSON,
    SourcingSearchFilterOnFunctionalSkillsFromJSONTyped,
    SourcingSearchFilterOnFunctionalSkillsToJSON,
} from './';
import type { SourcingSearchFilterOnIndustryExpertise } from './';
import {
    SourcingSearchFilterOnIndustryExpertiseFromJSON,
    SourcingSearchFilterOnIndustryExpertiseFromJSONTyped,
    SourcingSearchFilterOnIndustryExpertiseToJSON,
} from './';
import type { SourcingSearchFilterOnKeySkills } from './';
import {
    SourcingSearchFilterOnKeySkillsFromJSON,
    SourcingSearchFilterOnKeySkillsFromJSONTyped,
    SourcingSearchFilterOnKeySkillsToJSON,
} from './';
import type { SourcingSearchFilterOnLocation } from './';
import {
    SourcingSearchFilterOnLocationFromJSON,
    SourcingSearchFilterOnLocationFromJSONTyped,
    SourcingSearchFilterOnLocationToJSON,
} from './';
import type { SourcingSearchFormerEmployerActivityArea } from './';
import {
    SourcingSearchFormerEmployerActivityAreaFromJSON,
    SourcingSearchFormerEmployerActivityAreaFromJSONTyped,
    SourcingSearchFormerEmployerActivityAreaToJSON,
} from './';
import type { SourcingSearchFreelancerVertical } from './';
import {
    SourcingSearchFreelancerVerticalFromJSON,
    SourcingSearchFreelancerVerticalFromJSONTyped,
    SourcingSearchFreelancerVerticalToJSON,
} from './';
import type { SourcingSearchPageContext } from './';
import {
    SourcingSearchPageContextFromJSON,
    SourcingSearchPageContextFromJSONTyped,
    SourcingSearchPageContextToJSON,
} from './';
import type { SourcingSearchProfileAvailability } from './';
import {
    SourcingSearchProfileAvailabilityFromJSON,
    SourcingSearchProfileAvailabilityFromJSONTyped,
    SourcingSearchProfileAvailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchRequest
 */
export interface SourcingSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRequest
     */
    query: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    languages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    experienceLevels?: Array<SourcingSearchRequestExperienceLevelsEnum>;
    /**
     * 
     * @type {Array<SourcingSearchProfileAvailability>}
     * @memberof SourcingSearchRequest
     */
    availabilities?: Array<SourcingSearchProfileAvailability>;
    /**
     * 
     * @type {Array<SourcingSearchFreelancerVertical>}
     * @memberof SourcingSearchRequest
     */
    acceptedInVerticals?: Array<SourcingSearchFreelancerVertical>;
    /**
     * 
     * @type {SourcingSearchFilterOnDailyRate}
     * @memberof SourcingSearchRequest
     */
    dailyRate?: SourcingSearchFilterOnDailyRate;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    locatedInCountries?: Array<string>;
    /**
     * 
     * @type {SourcingSearchFilterOnLocation}
     * @memberof SourcingSearchRequest
     */
    location?: SourcingSearchFilterOnLocation;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    professionalBackgrounds?: Array<string>;
    /**
     * 
     * @type {SourcingSearchFilterOnIndustryExpertise}
     * @memberof SourcingSearchRequest
     */
    industryExpertise?: SourcingSearchFilterOnIndustryExpertise;
    /**
     * 
     * @type {SourcingSearchFilterOnFunctionalSkills}
     * @memberof SourcingSearchRequest
     */
    functionalSkills?: SourcingSearchFilterOnFunctionalSkills;
    /**
     * 
     * @type {SourcingSearchFilterOnKeySkills}
     * @memberof SourcingSearchRequest
     */
    keySkills?: SourcingSearchFilterOnKeySkills;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRequest
     */
    availabilityFrequencies?: Array<SourcingSearchRequestAvailabilityFrequenciesEnum>;
    /**
     * 
     * @type {Array<SourcingSearchFormerEmployerActivityArea>}
     * @memberof SourcingSearchRequest
     */
    formerEmployerActivityAreas?: Array<SourcingSearchFormerEmployerActivityArea>;
    /**
     * 
     * @type {SourcingSearchFilterOnBackground}
     * @memberof SourcingSearchRequest
     */
    background?: SourcingSearchFilterOnBackground;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    hasBeenRecentlyModified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    isSuperMalter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchRequest
     */
    isInterestedInInterim?: boolean;
    /**
     * 
     * @type {SourcingSearchPageContext}
     * @memberof SourcingSearchRequest
     */
    pageContext?: SourcingSearchPageContext;
}


/**
 * @export
 */
export const SourcingSearchRequestExperienceLevelsEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type SourcingSearchRequestExperienceLevelsEnum = typeof SourcingSearchRequestExperienceLevelsEnum[keyof typeof SourcingSearchRequestExperienceLevelsEnum];

/**
 * @export
 */
export const SourcingSearchRequestAvailabilityFrequenciesEnum = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    EveningsAndWeekends: 'EVENINGS_AND_WEEKENDS',
    FullTime: 'FULL_TIME'
} as const;
export type SourcingSearchRequestAvailabilityFrequenciesEnum = typeof SourcingSearchRequestAvailabilityFrequenciesEnum[keyof typeof SourcingSearchRequestAvailabilityFrequenciesEnum];


/**
 * Check if a given object implements the SourcingSearchRequest interface.
 */
export function instanceOfSourcingSearchRequest(value: object): value is SourcingSearchRequest {
    if (!('query' in value) || value['query'] === undefined) return false;
    return true;
}

export function SourcingSearchRequestFromJSON(json: any): SourcingSearchRequest {
    return SourcingSearchRequestFromJSONTyped(json, false);
}

export function SourcingSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'],
        'languages': json['languages'] == null ? undefined : json['languages'],
        'experienceLevels': json['experienceLevels'] == null ? undefined : json['experienceLevels'],
        'availabilities': json['availabilities'] == null ? undefined : ((json['availabilities'] as Array<any>).map(SourcingSearchProfileAvailabilityFromJSON)),
        'acceptedInVerticals': json['acceptedInVerticals'] == null ? undefined : ((json['acceptedInVerticals'] as Array<any>).map(SourcingSearchFreelancerVerticalFromJSON)),
        'dailyRate': json['dailyRate'] == null ? undefined : SourcingSearchFilterOnDailyRateFromJSON(json['dailyRate']),
        'locatedInCountries': json['locatedInCountries'] == null ? undefined : json['locatedInCountries'],
        'location': json['location'] == null ? undefined : SourcingSearchFilterOnLocationFromJSON(json['location']),
        'professionalBackgrounds': json['professionalBackgrounds'] == null ? undefined : json['professionalBackgrounds'],
        'industryExpertise': json['industryExpertise'] == null ? undefined : SourcingSearchFilterOnIndustryExpertiseFromJSON(json['industryExpertise']),
        'functionalSkills': json['functionalSkills'] == null ? undefined : SourcingSearchFilterOnFunctionalSkillsFromJSON(json['functionalSkills']),
        'keySkills': json['keySkills'] == null ? undefined : SourcingSearchFilterOnKeySkillsFromJSON(json['keySkills']),
        'availabilityFrequencies': json['availabilityFrequencies'] == null ? undefined : json['availabilityFrequencies'],
        'formerEmployerActivityAreas': json['formerEmployerActivityAreas'] == null ? undefined : ((json['formerEmployerActivityAreas'] as Array<any>).map(SourcingSearchFormerEmployerActivityAreaFromJSON)),
        'background': json['background'] == null ? undefined : SourcingSearchFilterOnBackgroundFromJSON(json['background']),
        'hasBeenRecentlyModified': json['hasBeenRecentlyModified'] == null ? undefined : json['hasBeenRecentlyModified'],
        'isSuperMalter': json['isSuperMalter'] == null ? undefined : json['isSuperMalter'],
        'isInterestedInInterim': json['isInterestedInInterim'] == null ? undefined : json['isInterestedInInterim'],
        'pageContext': json['pageContext'] == null ? undefined : SourcingSearchPageContextFromJSON(json['pageContext']),
    };
}

export function SourcingSearchRequestToJSON(value?: SourcingSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
        'languages': value['languages'],
        'experienceLevels': value['experienceLevels'],
        'availabilities': value['availabilities'] == null ? undefined : ((value['availabilities'] as Array<any>).map((v) => SourcingSearchProfileAvailabilityToJSON(v))),
        'acceptedInVerticals': value['acceptedInVerticals'] == null ? undefined : ((value['acceptedInVerticals'] as Array<any>).map((v) => SourcingSearchFreelancerVerticalToJSON(v))),
        'dailyRate': SourcingSearchFilterOnDailyRateToJSON(value['dailyRate']),
        'locatedInCountries': value['locatedInCountries'],
        'location': SourcingSearchFilterOnLocationToJSON(value['location']),
        'professionalBackgrounds': value['professionalBackgrounds'],
        'industryExpertise': SourcingSearchFilterOnIndustryExpertiseToJSON(value['industryExpertise']),
        'functionalSkills': SourcingSearchFilterOnFunctionalSkillsToJSON(value['functionalSkills']),
        'keySkills': SourcingSearchFilterOnKeySkillsToJSON(value['keySkills']),
        'availabilityFrequencies': value['availabilityFrequencies'],
        'formerEmployerActivityAreas': value['formerEmployerActivityAreas'] == null ? undefined : ((value['formerEmployerActivityAreas'] as Array<any>).map((v) => SourcingSearchFormerEmployerActivityAreaToJSON(v))),
        'background': SourcingSearchFilterOnBackgroundToJSON(value['background']),
        'hasBeenRecentlyModified': value['hasBeenRecentlyModified'],
        'isSuperMalter': value['isSuperMalter'],
        'isInterestedInInterim': value['isInterestedInInterim'],
        'pageContext': SourcingSearchPageContextToJSON(value['pageContext']),
    };
}

